export const FEEDBACK_CREATE = "/feedback/create";
